import { get, post } from '@/Api';
import { SelectItem } from '@/Models/Other/SelectItem';
import { Contract } from '@/Models/Tables/Contract';
import { ViewContract } from '@/Models/Views/ViewContract';


const name = 'Contract';

function getUrl(url: string) {
    return `${name}/${url}`;
}
export function getViews(): Promise<ViewContract[]> {
    return get(getUrl("getViews"));
}
export function add(data: Contract): Promise<ViewContract> {
    return post(getUrl("add"), data);
}
export function upd(data: Contract): Promise<ViewContract> {
    return post(getUrl("upd"), data);
}
export function del(id: number): Promise<number> {
    return get(getUrl("del"), { id });
}
export function getContractSelectItems(): Promise<SelectItem[]> {
    return get(getUrl("getSelectItems"));
}